import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import UsersTable from "../adminStores/usersTable.jsx";
import { getAdmins } from "../../api/admin";
import {FaCrown} from "react-icons/fa6";

function AdminUsers() {
  const { selectedLocation } = useSelector((state) => state.app);
  const [users, setUsers] = useState([]);
  const _getAdmins = async () => {
    await getAdmins().then((res) => {
      setUsers(res.admins);
    });
  };

  useEffect(() => {
    _getAdmins();
  }, []);

  if (!selectedLocation) return null;

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
      {/* Page header */}
      <div className="mb-8">
        {/* Title */}
        <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold flex items-center gap-1">
          Admins <FaCrown />
        </h1>
      </div>

      {/* Content */}
      <div className="bg-white dark:bg-theme-surface-accent shadow-lg rounded-sm mb-8">
        <div className="flex flex-col md:flex-row md:-mr-px">
          <div className="space-y-4 p-4 w-full">
            <UsersTable users={users} refetch={_getAdmins} isAdmin={true} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminUsers;
